/**
 * Company: SPHMedia
 * Description: [Brief description of the component]
 */

import { ComponentProps, ReactElement } from "react";
import { Link } from "react-router";
import cx from "classnames";

export type ReadMoreProps = {
  /** Optional className for the component. */
  className?: string;
  /** Optional boolean to animate the component. */
  isAnimated?: boolean;
} & Pick<ComponentProps<typeof Link>, "to">;

/**
 * This is the button displayed in lifestyle cards.
 */
const ReadMore = ({
  isAnimated = false,
  className,
  to,
}: ReadMoreProps): ReactElement => {
  return (
    <>
      <Link
        className={cx(
          "border-x-none relative inline-block w-[135px] whitespace-nowrap border-y-2 border-verticals-lifestyle px-3 py-1 text-center text-3xs font-bold leading-none tracking-[3px] text-verticals-lifestyle transition-[letter-spacing]",
          className,
          { "hover:border-x-2 hover:tracking-[0px]": isAnimated }
        )}
        to={to}
        target="_blank"
        rel="noopener"
      >
        READ MORE
      </Link>
    </>
  );
};

export default ReadMore;
